<template>
    <div class="bot_mobilebox">
        <img src="../../public/statics/img/mobile/bottoms.png" alt="">
        <div class="botsapply" @click="toapply()">申请入驻</div>
        <div class="botsfont">
            <p>© 2021 All Rights Reserved</p>
            <p> 苏州量子方舟网络科技有限公司 版权所有</p>
            <p>  <span class="bottomSpans">
                     <a href="https://beian.miit.gov.cn/" style="">苏ICP备18053448号-2</a>
                </span></p>
        </div>
    </div>

</template>

<script>
    export default {
        name: "bot_mobile",
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            toapply() {
                this.$router.push({
                    path: '/edition_mobile'
                })
            },
        },
    }
</script>

<style scoped lang='scss'>
    .bot_mobilebox {
        width: 100%;
        height: 8rem;
        display: flex;
        justify-content: center;
        overflow: hidden;
        position: relative;

        img {
            height: 100%;
            width: auto;
        }

        .botsapply {
            width: 10rem;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #ffffff;
            border: 1px solid #ffffff;
            border-radius: 6px;
            position: absolute;
            top: 0.8rem;
            font-family: "PingFang SC";
            font-size: 16px;
        }

        .botsfont {
            display: flex;
            flex-direction: column;

            position: absolute;
            bottom: 0.5rem;
            color: #ffffff;
            font-size: 12px;

        }

        .bottomSpans {
            cursor: pointer;

            a {
                text-decoration: none;
            }

            color: #ffffff;

            a:visited, a:link, a:active {
                color: #ffffff;
            }

            a:hover {
                color: #4f8aff;
            }
        }
    }
</style>